import { AppsyncConnector } from './connector';
import { 
    CreateLeapPatientEnrollmentRequestData, 
    createLeapPatientEnrollmentRequest, 
    onUpdateServiceEnrollment, 
    OnUpdateServiceEnrollmentData, 
    ServiceEnrollmentData 
} from './mutation';

export default class FullEnrollmentConnector extends AppsyncConnector {

    private enrollmentPatientId: string | undefined;

    protected get patientId() {
        return this.enrollmentPatientId;
    }

    protected get enrollmentQuery(): string {
        return createLeapPatientEnrollmentRequest;
    }
    protected get subscriptionQuery(): string {
        return onUpdateServiceEnrollment(this.sessionToken!);
    }
    
    protected getServicesFromMutation(response: CreateLeapPatientEnrollmentRequestData): string[] {
        this.enrollmentPatientId = response.data.createLeapPatientEnrollmentRequest.patient.id;
        return response.data.createLeapPatientEnrollmentRequest.serviceEnrollments.map(
            serviceEnrollment => serviceEnrollment.name
        );
    }

    protected getDataFromSubscription(response: OnUpdateServiceEnrollmentData): ServiceEnrollmentData {
        return response.data.onUpdateServiceEnrollment;
    }

    protected getRequestBody() {
        return {
            meta: {
				id: this.sessionToken,
				source: 'website',
				extension: [
					{
						id: 'lastUpdatedBy',
						url: 'lastUpdatedBy',
						valueIdentifier: {
							value: this.sessionToken,
							type: { text: 'Cognito' },
							assigner: { display: this.request?.product + ' website' },
						},
					},
				],
			},
            userSessionId: this.sessionToken,
            ...this.request
        }
    }
}